<div class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
  <div class="container mx-auto px-4 py-8">

    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center mb-4">
        <div class="bg-gradient-to-r from-blue-500 to-indigo-600 p-3 rounded-xl shadow-lg mr-4">
          <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
            </path>
          </svg>
        </div>
        <div>
          <h1 class="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
            Reportes de Comprobantes de Ingreso
          </h1>
          <p class="text-gray-600 mt-1">Genera reportes detallados de comprobantes de ingreso en Excel</p>
        </div>
      </div>
    </div>

    <!-- Main Content Card -->
    <div class="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">

      <!-- Card Header -->
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-100 p-6">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center">
          <svg class="w-5 h-5 mr-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z">
            </path>
          </svg>
          Configuración del Reporte
        </h2>
        <p class="text-gray-600 text-sm mt-1">Seleccione los parámetros para generar el reporte</p>
      </div>

      <!-- Form Content -->
      <div class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">

          <!-- Selector de Tipo de Fecha -->
          <div class="space-y-2">
            <label for="dateType" class="block text-sm font-semibold text-gray-700 flex items-center">
              Tipo de Fecha *
            </label>
            <p-dropdown id="dateType" [(ngModel)]="dateType" [options]="dateTypeOptions" optionLabel="label"
              optionValue="value" class="w-full custom-dropdown">
            </p-dropdown>
          </div>


          <!-- Selector de Fecha Inicio -->
          <div class="space-y-2">
            <label for="startDate" class="block text-sm font-semibold text-gray-700 flex items-center">
              Fecha Inicio *
            </label>
            <p-calendar [(ngModel)]="startDate" [showIcon]="true" inputId="startDate" dateFormat="dd/mm/yy"
              [iconDisplay]="'input'" styleClass="w-full"
              inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
              [appendTo]="'body'"></p-calendar>
          </div>

          <!-- Selector de Fecha Fin -->
          <div class="space-y-2">
            <label for="endDate" class="block text-sm font-semibold text-gray-700 flex items-center">

              Fecha Fin *
            </label>
            <p-calendar [(ngModel)]="endDate" [showIcon]="true" inputId="endDate" dateFormat="dd/mm/yy"
              styleClass="w-full" [iconDisplay]="'input'" [appendTo]="'body'"
              inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"></p-calendar>
          </div>

          <!-- Selector de Banco -->
          <div class="space-y-2">
            <label for="bank" class="block text-sm font-semibold text-gray-700 flex items-center">
              <svg class="w-4 h-4 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H7m2 0v-5a2 2 0 012-2h2a2 2 0 012 2v5m-6 0V9a2 2 0 012-2h2a2 2 0 012 2v8">
                </path>
              </svg>
              Banco (Opcional)
            </label>
            <p-dropdown id="bank" [(ngModel)]="selectedBankId" [options]="banksDropdown" [showClear]="true"
              [filter]="true" placeholder="Todos los bancos" optionLabel="label" optionValue="value"
              class="w-full custom-dropdown">
            </p-dropdown>
          </div>

          <!-- Selector de Empresa -->
          <div class="space-y-2">
            <label for="company" class="block text-sm font-semibold text-gray-700 flex items-center">
              <svg class="w-4 h-4 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H7m2 0v-5a2 2 0 012-2h2a2 2 0 012 2v5m-6 0V9a2 2 0 012-2h2a2 2 0 012 2v8">
                </path>
              </svg>
              Empresa (Opcional)
            </label>
            <p-dropdown id="company" [(ngModel)]="selectedCompanyId" [options]="companiesDropdown" [showClear]="true"
              [filter]="true" placeholder="Todas las empresas" optionLabel="label" optionValue="value"
              (onFilter)="onSearchCompanies($event)" class="w-full custom-dropdown">
            </p-dropdown>
          </div>

          <!-- Selector de Participante -->
          <div class="space-y-2">
            <label for="participant" class="block text-sm font-semibold text-gray-700 flex items-center">
              <svg class="w-4 h-4 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
              Participante (Opcional)
            </label>
            <p-dropdown id="participant" [(ngModel)]="selectedParticipantId" [options]="participantsDropdown"
              [showClear]="true" [filter]="true" placeholder="Todos los participantes" optionLabel="label"
              optionValue="value" (onFilter)="onSearchParticipants($event)" class="w-full custom-dropdown">
            </p-dropdown>
          </div>

          <!-- Selector de Proyecto -->
          <div class="space-y-2">
            <label for="project" class="block text-sm font-semibold text-gray-700 flex items-center">
              <svg class="w-4 h-4 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                </path>
              </svg>
              Proyecto (Opcional)
            </label>
            <p-dropdown id="project" [(ngModel)]="selectedProjectId" [options]="projectsDropdown" [showClear]="true"
              [filter]="true" placeholder="Todos los proyectos" optionLabel="label" optionValue="value"
              (onFilter)="onSearchProjects($event)" class="w-full custom-dropdown">
            </p-dropdown>
          </div>

          <!-- Selector de Metodo de Pago -->
          <div class="space-y-2">
            <label for="paymentMethod" class="block text-sm font-semibold text-gray-700 flex items-center">
              <svg class="w-4 h-4 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
              </svg>
              Método de Pago (Opcional)
            </label>
            <p-dropdown id="paymentMethod" [(ngModel)]="selectedPaymentMethodId" [options]="paymentMethodsDropdown"
              [showClear]="true" [filter]="true" placeholder="Todos los métodos" optionLabel="label" optionValue="value"
              class="w-full custom-dropdown">
            </p-dropdown>
          </div>

          <!-- Selector de Ordenamiento -->
          <div class="space-y-2">
            <label for="sortBy" class="block text-sm font-semibold text-gray-700 flex items-center">
              <svg class="w-4 h-4 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"></path>
              </svg>
              Ordenar por
            </label>
            <p-dropdown id="sortBy" [(ngModel)]="sortBy" [options]="sortByOptions" optionLabel="label"
              optionValue="value" class="w-full custom-dropdown">
            </p-dropdown>
          </div>

          <!-- Selector de Dirección de Orden -->
          <div class="space-y-2">
            <label for="sortDirection" class="block text-sm font-semibold text-gray-700 flex items-center">
              <svg class="w-4 h-4 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"></path>
              </svg>
              Dirección
            </label>
            <p-dropdown id="sortDirection" [(ngModel)]="sortDirection" [options]="sortDirectionOptions" optionLabel="label"
              optionValue="value" class="w-full custom-dropdown">
            </p-dropdown>
          </div>

        </div>

        <!-- Current Selection Display -->
        <div class="bg-gray-50 rounded-lg p-4 mb-6">
          <h3 class="text-lg font-semibold text-gray-800 mb-2">Selección Actual:</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
            <div>
              <span class="font-medium text-gray-600">Período:</span>
              <span class="ml-2 text-gray-800">{{ startDate | date:'dd/MM/yy' }} - {{ endDate | date:'dd/MM/yy'
                }}</span>
            </div>
            <div>
              <span class="font-medium text-gray-600">Banco:</span>
              <span class="ml-2 text-gray-800">{{ selectedBankName }}</span>
            </div>
            <div>
              <span class="font-medium text-gray-600">Empresa:</span>
              <span class="ml-2 text-gray-800">{{ selectedCompanyName }}</span>
            </div>
            <div>
              <span class="font-medium text-gray-600">Participante:</span>
              <span class="ml-2 text-gray-800">{{ selectedParticipantName }}</span>
            </div>
            <div>
              <span class="font-medium text-gray-600">Proyecto:</span>
              <span class="ml-2 text-gray-800">{{ selectedProjectName }}</span>
            </div>
            <div>
              <span class="font-medium text-gray-600">Método de Pago:</span>
              <span class="ml-2 text-gray-800">{{ selectedPaymentMethodName }}</span>
            </div>
            <div>
              <span class="font-medium text-gray-600">Tipo:</span>
              <span class="ml-2 text-green-600 font-medium">Comprobantes de Ingreso</span>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row justify-end gap-4">
          <button (click)="downloadExcelReport()" [disabled]="!startDate || !endDate || loading"
            class="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl shadow-lg hover:from-blue-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center min-w-[200px]">

            <div *ngIf="loading" class="flex items-center">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-3"></div>
              <span>Generando Excel...</span>
            </div>

            <div *ngIf="!loading" class="flex items-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z">
                </path>
              </svg>
              <span>Descargar Excel</span>
            </div>
          </button>
        </div>

      </div>
    </div>

    <!-- My Reports Section -->
    <app-recent-report-jobs></app-recent-report-jobs>

    <!-- Help Section -->
    <div class="mt-8 bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <svg class="w-6 h-6 text-blue-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div class="ml-4">
          <h4 class="text-lg font-medium text-gray-800">Información del Reporte</h4>
          <div class="mt-2 text-sm text-gray-600 space-y-1">
            <p>• El reporte incluye todos los comprobantes de ingreso del período seleccionado</p>
            <p>• Los datos se exportan en formato Excel (.xlsx) con información detallada</p>
            <p>• Incluye montos, fechas, participantes, proyectos y estados de conciliación</p>
            <p>• Útil para análisis financiero y seguimiento de ingresos por proyecto</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>